import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home/index.vue'
import TrackRemind from './views/trackRemind/index.vue'
import TrackRecord from './views/trackRecord/index.vue'
import EditRecord from './views/editRecord/index.vue'
import InquiryRecord from './views/inquiryRecord/index.vue'
import InquiryInfo from './views/inquiryInfo/index.vue'
import PatientInfo from './views/patientInfo/index.vue'
import Assistant from './views/assistant/index.vue'
import BindDoctor from './views/bindDoctor/index.vue'
import BindDoctorUpdate from './views/bindDoctorUpdate/index.vue'

import PatientInfoEdit from './views/patientInfo/edit.vue'
import InquiryInfoEdit from './views/inquiryInfo/edit.vue'
import InquiryInfoLogistics from './views/inquiryInfo/logistics.vue'
import InquiryInfoRecord from './views/inquiryInfo/record.vue'
import InquiryInfoPrescription from './views/inquiryInfo/prescription.vue'

import MoreEffective from '@/views/moreEffective/index.vue'
import EditMoreEffective from '@/views/moreEffective/editMoreEffective'


import CreateAsk from '@/views/ask/createAsk.vue'
import AskOrder from '@/views/ask/askOrder.vue'

import Reservation from '@/views/reservation/index.vue'
import ReservationPay from '@/views/reservation/pay.vue'
import ReservationEdit from '@/views/reservation/edit.vue'
import PreAsk from '@/views/ask/preAsk.vue'

import Evaluate from '@/views/evaluate/index.vue'

import receptionSummary from '@/views/reception/summary.vue'


import devLogin from '@/views/dev/login.vue'

import OrderAdvice from '@/views/order/advice/index.vue'

import ConsultationRecord from '@/views/consultation/record.vue'
import ConsultationPay from '@/views/consultation/pay.vue'

import Chat from '@/views/chat/index.vue'
import medicationPayment from "@/views/userPay/medicationPayment.vue";
import registeredPayment from "@/views/userPay/registeredPayment.vue";
import informedConsent from "@/views/userPay/informedConsent.vue";
import paymentSuccessful from "@/views/userPay/paymentSuccessful.vue";
import productDetail from '@/views/teamOrders/productDetail/index.vue'
import productLogistics from '@/views/teamOrders/logistics/index.vue'
import drugDetail from '@/views/teamOrders/drugDetail/index.vue'
Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {keepAlive: true}
        },
        {
            path: '/trackRemind',
            name: 'TrackRemind',
            component: TrackRemind,
            meta: {keepAlive: true}
        },
        {
            path: '/trackRecord',
            name: 'TrackRecord',
            component: TrackRecord,
            meta: {keepAlive: true}
        },
        {
            path: '/editRecord',
            name: 'EditRecord',
            component: EditRecord
        },
        {
            path: '/inquiryRecord',
            name: 'InquiryRecord',
            component: InquiryRecord,
            meta: {keepAlive: true}
        },
        {
            path: '/inquiryInfo',
            name: 'InquiryInfo',
            component: InquiryInfo
        },
        {
            path: '/inquiryInfo/edit',
            name: 'InquiryInfoEdit',
            component: InquiryInfoEdit
        },
        {
            path: '/inquiryInfo/logistics',
            name: 'InquiryInfoLogistics',
            component: InquiryInfoLogistics
        },
        {
            path: '/inquiryInfo/record',
            name: 'InquiryInfoRecord',
            component: InquiryInfoRecord
        },
        {
            path: '/inquiryInfo/prescription',
            name: 'InquiryInfoPrescription',
            component: InquiryInfoPrescription
        },
        {
            path: '/patientInfo',
            name: 'PatientInfo',
            component: PatientInfo
        },
        {
            path: '/patientInfo/edit',
            name: 'PatientInfoEidt',
            component: PatientInfoEdit
        },
        {
            path: '/assistant',
            name: 'Assistant',
            component: Assistant
        },
        {
            path: '/bindDoctor',
            name: 'BindDoctor',
            component: BindDoctor
        },
        {
            path: '/bindDoctorUpdate',
            name: 'BindDoctorUpdate',
            component: BindDoctorUpdate
        },
        {
            path: '/moreEffective',
            name: 'MoreEffective',
            component: MoreEffective,
            meta: {keepAlive: true}
        },
        {
            path: '/editMoreEffective',
            name: 'EditMoreEffective',
            component: EditMoreEffective,
        },
        {
            path: '/createAsk',
            name: 'CreateAsk',
            component: CreateAsk,
        },
        {
            path: '/askOrder',
            name: 'AskOrder',
            component: AskOrder,
        },
        {
            path: '/reservation',
            name: 'Reservation',
            component: Reservation
        },
        {
            path: '/reservation/pay',
            name: 'ReservationPay',
            component: ReservationPay
        },
        {
            path: '/reservation/edit',
            name: 'ReservationEdit',
            component: ReservationEdit
        },
        {
            path: '/preAsk',
            name: 'PreAsk',
            component: PreAsk
        },
        {
            path: '/evaluate',
            name: 'Evaluate',
            component: Evaluate
        },
        {
            path: '/dev/login',
            name: 'DevLogin',
            component: devLogin
        },
        {
            path: '/reception/summary',
            name: 'receptionSummary',
            component: receptionSummary
        },
        {
            path: '/order/advice',
            name: 'OrderAdvice',
            component: OrderAdvice
        },
        {
            path: '/consultation/record',
            name: 'ConsultationRecord',
            component: ConsultationRecord
        },
        {
            path: '/consultation/pay',
            name: 'ConsultationPay',
            component: ConsultationPay
        },
        {
            path: '/chat',
            name: 'Chat',
            component: Chat
        },
        {
            path: '/medicationPayment',
            name: 'MedicationPayment',
            component: medicationPayment
        }, {
            path: '/registeredPayment',
            name: 'RegisteredPayment',
            component: registeredPayment
        }, {
            path: '/informedConsent',
            name: 'InformedConsent',
            component: informedConsent
        },
        {
            path: '/paymentSuccessful',
            name: 'PaymentSuccessful',
            component: paymentSuccessful
        },
        {
            path: '/teamOrders/productDetail/index',
            name: 'productDetail',
            component: productDetail
        },
        {
            path: '/teamOrders/logistics/index',
            name: 'productLogistics',
            component: productLogistics
        },
        {
            path: '/teamOrders/drugDetail/index',
            name: 'drugDetail',
            component: drugDetail
        },
        
    ]
})
